import { defineStore } from 'pinia'
import { Store } from '../apis/types/store'

export const useUserStore = defineStore('userStore', {
  state: () => ({
    stores: [] as Store[],
  }),

  actions: {
    setStores(stores: Store[]) {
      this.stores = stores
    },

    resetStore() {
      this.stores = []
    },
  },
})
